import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class ActionsService {

  static getAll(options=[], minimal=false) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}actions${params}&minimal=${minimal}`).then((data) => {
        resolve({ actions: data.data.content, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAssociatedAlertConfigs(actionId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}actions/${actionId}/alertConfigurations`).then((data) => {
        resolve({ alertConfigurations: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static archiveAction(actionId) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}actions/${actionId}/archive`).then((data) => {
        resolve({ action: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static listAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}actions/listAll`).then((data) => {
        resolve({ actions: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static get(actionId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}actions/${actionId}`).then((data) => {
        resolve({ action: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static save(action) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}actions/${action.id}`, action).then((data) => {
        resolve({ action: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static add(action) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}actions`, action).then((data) => {
        resolve({ action: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default ActionsService;
